import { Component } from '@angular/core';

import { Modal, TranslatePipe } from '@softline/ui-core';
import { Bestellung } from '../../types/bestellung';
import { KopfdatenComponent } from '../../components/kopfdaten/kopfdaten.component';

@Component({
  selector: 'soft-bestellung-uebernehmen',
  imports: [KopfdatenComponent, TranslatePipe],
  templateUrl: './bestellung-uebernehmen-dialog.component.html',
  styleUrls: ['./bestellung-uebernehmen-dialog.component.css'],
})
export class BestellungUebernehmenDialogComponent implements Modal<string> {
  close!: (result: string) => void;

  public _bestellung?: Bestellung;
  public lieferscheinnummer = '';

  set bestellung(bestellung: Bestellung) {
    this._bestellung = bestellung;
  }

  registerCloseHandler(handler: (result: string) => void): void {
    this.close = handler;
  }

  lieferscheinnummerChange(lieferscheinnummer: string) {
    console.log('lieferscheinnummer', lieferscheinnummer);
    this.lieferscheinnummer = lieferscheinnummer;
  }
}
